import { FeatureActionConstants } from "../action-constants";
import EmptyState from "../store/emptyState";
import globalReducerHelper from "./globalReducerHelper";

const { SET_ACTIVE_FEATURES, SET_ABTEST_ACTIVE_FEATURES } =
  FeatureActionConstants;

const feature = (state = EmptyState.feature, action) => {
  const { type, payload } = action;

  switch (type) {
    case SET_ACTIVE_FEATURES: {
      return Object.assign({}, state, {
        activeFeatures: action.payload
      });
    }
    case SET_ABTEST_ACTIVE_FEATURES: {
      return Object.assign({}, state, {
        abTestActiveFeatures: action.payload
      });
    }
    default:
      return globalReducerHelper(
        state,
        type,
        payload && payload.feature,
        EmptyState.feature
      );
  }
};

export default feature;
